import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ShowdownDirective } from '../../../directives/animations/showdown.directive';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';

@Component({
  selector: 'section[app-about-principles-section]',
  imports: [MatIconModule, ShowleftDirective, ShowdownDirective],
  templateUrl: './about-principles-section.html',
  styleUrl: './about-principles-section.scss',
})
export class AboutPrinciplesSection {
}
